import { forwardRef, useState } from 'react';
import { Field } from 'formik';
import { FormControl, Stack, FormLabel, Box, Text } from '@chakra-ui/react';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    dropDownFormStyle,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { Select } from 'chakra-react-select';
import { autoApprovalOptions } from '../consts';

const ApprovalCodeAutoApprove = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { createMode } = walkthroughIds;
    const ChakraSelect = forwardRef((props, ref) => (
        <Select selectedOptionColor="brand" ref={ref} {...props} />
    ));
    ChakraSelect.displayName = "ChakraSelect";

    return (
        <FormControl
            isInvalid={!!errors.autoApprove && touched.autoApprove}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Auto Approval
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select if approval should be automatic.
                    </Text>
                </Box>
                <Box
                    flex="1"
                    sx={{
                        paddingTop: '15px',
                    }}
                >
                    <Field name="autoApprove">
                        {({ form }) => {
                            const selectedOption = autoApprovalOptions.find(
                                (op) => op.value === form.values.autoApprove
                            ) || null;
                            return (
                                <ChakraSelect
                                    minWidth="410px"
                                    width="100%"
                                    data-walkthroughid={createMode.ufAutoApproveSelect}
                                    options={autoApprovalOptions}
                                    placeholder="- Select Auto Approval -"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                    getOptionLabel={(i) => i.label}
                                    getOptionValue={(i) => i.value}
                                    chakraStyles={dropDownFormStyle(darkMode)}
                                    isLoading={form.isSubmitting}
                                    isDisabled={form.isSubmitting}
                                    value={selectedOption}
                                    onChange={(option) => {
                                        form.setFieldValue('autoApprove', option.value);
                                        form.validateField('autoApprove');
                                    }}
                                    onBlur={() => {
                                        form.setFieldTouched('autoApprove', true);
                                    }}
                                />
                            );
                        }}
                    </Field>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select if approval should be automatic."
                        ariaLabel="approval-code-auto-approve-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default ApprovalCodeAutoApprove;